import { FormGroup } from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ModalOptions } from "..";
import { ModalComponent } from "../../modal/modal.component";


// This is being made defunct
export function displayModal(content: any, size: string, options: ModalOptions, modalService: NgbModal): NgbModalRef {
  const windowref = modalService.open(ModalComponent, { size: size, backdrop: 'static', windowClass: options.windowClass, keyboard: false, scrollable: options.scrollable ?? false });
  windowref.componentInstance.options = options;
  windowref.componentInstance.contentTemplate = content;
  return windowref;
}
export function displayModalComponent(component: any, size: string, options: ModalOptions, modalService: NgbModal, params: any[]): NgbModalRef {
  const windowref = modalService.open(component, { size: size, backdrop: 'static', windowClass: options.windowClass, keyboard: false, scrollable: options.scrollable ?? false });
  windowref.componentInstance.options = options;
  if (params) {
    windowref.componentInstance.params = params;
  }
  return windowref;
}
export function displayModalComponentWoOptions(component: any, size: string, modalService: NgbModal): NgbModalRef {
  const windowref = modalService.open(component, { size: size, backdrop: 'static', keyboard: false });
  return windowref;
}

export function displayModalEditorComponent(component: any, size: string, options: ModalOptions, modalService: NgbModal, form: FormGroup): NgbModalRef {
  const windowref = modalService.open(component, { size: size, backdrop: 'static', windowClass: options.windowClass, keyboard: false, scrollable: options.scrollable ?? false });
  windowref.componentInstance.options = options;
  if (form) {
    windowref.componentInstance.form = form;
  }
  return windowref;
}
